import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/mobile/shevron_right.svg'


const _hoisted_1 = { class: "flex flex-col px-10" }
const _hoisted_2 = { class: "flex items-center justify-center relative mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

import BaseButton from '@/components/common/BaseButton.vue';
import Slider from '@/components/common/Slider.vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SeventhSection',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseButton, {
        text: _unref(t)('main-page.excursion.title'),
        type: "subtitle-m",
        "padding-x": "64",
        "padding-y": "12",
        color: "var(--black-color)",
        ui: "primary"
      }, null, 8, ["text"]),
      _createElementVNode("div", {
        class: "absolute right-0 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/excursions')))
      }, _hoisted_4)
    ]),
    _createVNode(Slider)
  ]))
}
}

})